/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Birthdays. Format MM-dd
 */
export interface UserFilterParamBirthdaysInner { 
    month?: UserFilterParamBirthdaysInner.MonthEnum;
    monthValue?: number;
    dayOfMonth?: number;
}
export namespace UserFilterParamBirthdaysInner {
    export const MonthEnum = {
        January: 'JANUARY',
        February: 'FEBRUARY',
        March: 'MARCH',
        April: 'APRIL',
        May: 'MAY',
        June: 'JUNE',
        July: 'JULY',
        August: 'AUGUST',
        September: 'SEPTEMBER',
        October: 'OCTOBER',
        November: 'NOVEMBER',
        December: 'DECEMBER'
    } as const;
    export type MonthEnum = typeof MonthEnum[keyof typeof MonthEnum];
}


